import axios from 'axios';
import React, { Component } from 'react';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';

const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaEstudMatr = ApiUrl + "listestudmatriperiodcarrehoraspract" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlGuardarHorasPractica = ApiUrl + "horaspracticaslabestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlBuscarHorasPractica = ApiUrl + "horaspracticaslabestud/buscar" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaDocsPracticasEst = ApiUrl + "doc-pract-lab-estud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlRespuestaDocumentos = ApiUrl + "respdocpractlabestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarEntidadF = ApiUrl + "entidad-formadora-act" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // URL corregida para que coincida con la API de Laravel
const urlListarTutoresEntidad = ApiUrl + "entidad-formadora-tutores" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"; // Ruta para listar los tutores
const urlListaDocentes = ApiUrl + "listusuariosadmdocen" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfoCarrera = ApiUrl + "infocarrselect" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";


const itemsPerPage = 10;


export default class GestionHorasPracticas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            carrera: [],
            periodos: [],
            estud: [],
            EstudianteBackup: [],
            documentosPracticas: [],
            reporteestudiantes: [],
            auxreporte: [],
            listaniveles: [],
            textBuscar: "",
            idCarrera: "",
            idPeriodo: "",
            estado: "",

            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,


            // MODAL HORAS
            modalHoras: false,
            estudianteSeleccionado: null,
            horasAsignadasPeriodo: "",
            horasCumplidasPeriodo: "",
            observacion: "",
            idHoraPracticaExistente: null,
            listaauxiliar: [],
            //ENTIDADES
            entidades: [],
            tutoresempresariales: [],
            docentes: [],
        };
    }


    componentDidMount() {
        axios.get(baseUrlPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                if (listaperiodos?.length) this.setState({ periodos: listaperiodos });
            });

        axios.get(carrerasUrl)
            .then(res => this.setState({ carrera: res.data }));



        axios.get(urlListarEntidadF)
            .then(response => {
                const listaent = response.data.data;
                this.setState({ entidades: listaent });

            })
        axios.get(urlListaDocentes)
            .then(res => {
                const docentes = res.data.data;
                this.setState({ docentes });
            })
        //Ocultar el divReporteDocPractLab
        $("#divReporteDocPractLab").hide();
    }

    handleChangeSelectNivel = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        $("#divReporteDocPractLab").hide();
        axios
            .post(urlInfoCarrera, {
                idCarreraS: this.state.idCarrera
            })
            .then(response => {
                const codigocarrest = response.data.objcarrea[0].id_carrera;
                const descripcarrest = response.data.objcarrea[0].descripcion_carrera;
                const nivelcarrest = response.data.objcarrea[0].num_niveles;
                this.setState({ codigoCarrE: codigocarrest });
                this.setState({ descripCarrE: descripcarrest });
                this.setState({ numnivelE: nivelcarrest });
                let listaniveles1 = []
                for (let i = 1; i <= nivelcarrest; i++) {
                    let fila = {
                        codnivel: i,
                        valor: i
                    };
                    listaniveles1.push(fila);
                }
                this.setState({ listaniveles: listaniveles1 });
            })
    }
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;   //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }


    handlePageClick = ({ selected }) => {
        const { listaauxiliar } = this.state;
        const total = listaauxiliar.length;
        const pageSize = itemsPerPage;

        if (total === 0) return;

        const start = selected * pageSize;
        const end = Math.min(start + pageSize, total);
        const currentItems = listaauxiliar.slice(start, end);

        this.setState({
            currentItems,
            EstudianteBackup: currentItems,
            itemOffset: start,
            currentPage: selected,
        });
    };

    handleChangeListTutorEmpEnt = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios.get(urlListarTutoresEntidad, {
            params: { entidad_id: this.state.idEntidad },  // Enviar el ID de la entidad
        })
            .then(response => {
                this.setState(prevState => ({
                    tutoresempresariales: response.data.tutores, // Los tutores de la entidad
                    entidadSeleccionada: this.state.idEntidad, // Establecer la entidad seleccionada
                }));
            })
            .catch(error => {
                console.error("Error al obtener los tutores", error);
                swal("Error", "No se pudieron obtener los tutores.", "error");
            });

    }
    listarEstudiantes = async () => {
        $("#divReporteDocPractLab").hide();

        const { idCarrera, idPeriodo, idNivelCarr } = this.state;

        if (!idCarrera || !idPeriodo || !idNivelCarr) {
            swal("Advertencia", "Seleccione una carrera, período y nivel", "warning");
            return;
        }

        // Calcular horas pendientes
        this.obtenerHorasPracticasCarrera(idPeriodo, idCarrera);

        this.setState({
            listaauxiliar: [],
            estud: [],
            EstudianteBackup: [],
            currentItems: [],
            pageCount: 0,
            itemOffset: 0,
            currentPage: 0,
        });

        try {
            const response = await axios.post(urlListaEstudMatr, {
                idcarrerae: idCarrera,
                idperiodoe: idPeriodo,
                idnivel: idNivelCarr,
            });

            if (response.data.success) {
                const listaauxiliar = (response.data.data || []).sort((a, b) => {
                    const ap1 = a.primer_apellido_estudiante.localeCompare(b.primer_apellido_estudiante);
                    if (ap1 !== 0) return ap1;
                    const ap2 = a.segundo_apellido_estudiante.localeCompare(b.segundo_apellido_estudiante);
                    if (ap2 !== 0) return ap2;
                    const nom1 = a.primer_nombre_estudiante.localeCompare(b.primer_nombre_estudiante);
                    if (nom1 !== 0) return nom1;
                    return a.segundo_nombre_estudiante.localeCompare(b.segundo_nombre_estudiante);
                });

                const total = listaauxiliar.length;
                const pageCount = Math.ceil(total / itemsPerPage);
                const currentItems = listaauxiliar.slice(0, itemsPerPage);

                this.setState({
                    listaauxiliar,
                    estud: listaauxiliar,
                    EstudianteBackup: listaauxiliar,
                    currentItems,
                    pageCount,
                    itemOffset: 0,
                    currentPage: 0,
                });


            } else {
                swal("Información", "No existen datos para mostrar", "info");
            }
        } catch {
            swal("Error", "No se pudo conectar con el servidor", "error");
        }
    };

    handleChangeObservacion = (e, idDocumento) => {
        const nuevaObservacion = e.target.value;

        this.setState((prevState) => ({
            documentosPracticas: prevState.documentosPracticas.map((doc) => {
                if (doc.id_documento_practica_laboral === idDocumento) {
                    return { ...doc, observacion_documento: nuevaObservacion };
                }
                return doc;
            }),
        }));
    };

    seleccionarEstudiantePracticas = async (estudiante) => {
        if (!this.state.idCarrera || !this.state.idPeriodo) {
            swal("Aviso", "Seleccione carrera y período antes de listar documentos.", "info");
            return;
        }
        await this.setState({ idEstudianteSelect: estudiante.id_estudiante });
        await this.setState({ idHorasPractLabEstud: estudiante.id_hor_prac_lab_est });
        axios.post(urlListaDocsPracticasEst, {
            idCarrera: this.state.idCarrera,
            idEstudiante: estudiante.id_estudiante,
            idPeriodo: this.state.idPeriodo,
        })
            .then(res => {
                if (res.data?.success) {
                    this.setState({ documentosPracticas: res.data.data || [] });

                    $("#divReporteDocPractLab").show();
                } else {
                    this.setState({ documentosPracticas: [] });
                    swal("Información", "El estudiante no tiene horas prácticas registradas en este período.", "info");
                    $("#divReporteDocPractLab").hide();
                }
            })
            .catch(() => {
                this.setState({ documentosPracticas: [] });
                swal("Error", "No se pudo obtener la información.", "error");
                $("#divReporteDocPractLab").hide();
            });
    };
    mostrarModalDescripDocumento = (registro) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: registro || ''
        });
    };
    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    }

    /*handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });

        // Opcional: si quieres que al cambiar nivel se liste automáticamente
        if (name === "idNivelCarr") {
            this.listarEstudiantes();
        } // Opcional: si quieres que al cambiar nivel se liste automáticamente
        if (name === "idNivelCarr") {
            this.listarEstudiantes();
        }

    };*/
    handleChange = async (e) => {
        const { name, value } = e.target;
        await this.setState({ [name]: value });

        // Opcional: si quieres que al cambiar nivel se liste automáticamente
        if (name === "idNivelCarr") {
            this.listarEstudiantes();
        }
    };

    handleChangePeriodo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        $("#divReporteDocPractLab").hide();


    };


    obtenerHorasPracticasCarrera(idPeriodo, idCarreraSeleccionada) {

        const urlHoras =
            `${ApiUrl}horas-practicaslab-carrera/${idPeriodo}/${idCarreraSeleccionada}?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71`;

        return axios.get(urlHoras)
            .then(resHoras => {

                let horasCarrera = 0;

                if (resHoras.data.success) {
                    horasCarrera = Number(resHoras.data.horas_practicas_laborales) || 0;
                }

                this.setState({
                    horasPracticasLaboralesCarrera: horasCarrera
                });

                return horasCarrera;
            })
            .catch(() => {
                this.setState({ horasPracticasLaboralesCarrera: 0 });
                return 0;
            });
    }






    // ==================== MODAL HORAS ====================
    abrirModalHoras = (estudiante) => {
        this.setState({
            estudianteSeleccionado: estudiante,
            modalHoras: true,
            horasAsignadasPeriodo: "",
            horasCumplidasPeriodo: "",
            observacion: "",
            idHoraPracticaExistente: null,
            idTutorAcad: "",
            idTutorEmp: "",
            idEntidad: "",
            horasFaltanteCarr: "",
        });
        var horasfaltante = this.state.horasPracticasLaboralesCarrera - estudiante.total_horas_cumplidas
        this.setState({ horasFaltanteCarr: horasfaltante });
        axios.post(urlBuscarHorasPractica, {
            est_id: estudiante.id_estudiante,
            car_id: this.state.idCarrera,
            per_id: this.state.idPeriodo,
        })
            .then(res => {
                if (res.data.data) {
                    const h = res.data.data;
                    this.setState({
                        horasAsignadasPeriodo: h.hor_asig,
                        horasCumplidasPeriodo: h.hor_cump,
                        observacion: h.obs || "",
                        idHoraPracticaExistente: h.id,
                        idTutorAcad: h.tutor_acad_id,
                        idTutorEmp: h.tutor_emp_id,
                        idEntidad: h.entidad_id,
                    });

                    $(function () {

                        $("#idTutorAcad").val(h.tutor_acad_id);

                    });
                    //Llamar
                    axios.get(urlListarTutoresEntidad, {
                        params: { entidad_id: h.entidad_id },  // Enviar el ID de la entidad
                    })
                        .then(response => {
                            this.setState(prevState => ({
                                tutoresempresariales: response.data.tutores, // Los tutores de la entidad
                                entidadSeleccionada: this.state.idEntidad, // Establecer la entidad seleccionada
                            }));


                            //Seleccionar
                            $(function () {

                                $("#idTutorEmp").val(h.tutor_emp_id);

                            });
                        })
                        .catch(error => {
                            console.error("Error al obtener los tutores", error);
                            swal("Error", "No se pudieron obtener los tutores.", "error");
                        });




                }
            });
    };

    cerrarModal = () => this.setState({ modalHoras: false });

    // ==================== GUARDAR O ACTUALIZAR ====================
    guardarHorasPractica = async () => {

        const {
            estudianteSeleccionado,
            idCarrera,
            idPeriodo,
            horasAsignadasPeriodo,
            horasCumplidasPeriodo,
            observacion,
            idHoraPracticaExistente,
            idEntidad,
            idTutorEmp,
            idTutorAcad,
            horasFaltanteCarr,
        } = this.state;
        // 🧩 Validaciones básicas
        if (!estudianteSeleccionado || !idCarrera || !idPeriodo) {
            swal("Error", "Seleccione estudiante, carrera y período", "error");
            return;
        }

        const horasAsignadas = Number(horasAsignadasPeriodo) || 0;
        const horasCumplidas = Number(horasCumplidasPeriodo) || 0;
        const horasFaltantes = Number(horasFaltanteCarr) || 0;

        // 🚫 Validar que no sean valores negativos
        if (horasAsignadas < 0 || horasCumplidas < 0) {
            swal("Error", "Las horas no pueden ser valores negativos.", "warning");
            return;
        }
      
        // ⚠️ Validar que las cumplidas no superen a las asignadas
        if (horasCumplidas > horasAsignadas) {
            swal("Error", "Las horas cumplidas no pueden ser mayores que las horas asignadas.", "warning");
            return;
        }
        // 🧾 Construir el payload
        const payload = {
            est_id: estudianteSeleccionado.id_estudiante,
            car_id: idCarrera,
            per_id: idPeriodo,
            hor_asig: horasAsignadas,
            hor_cump: horasCumplidas,
            obs: observacion || "",
            entidad_id: idEntidad,
            tutor_acad_id: idTutorAcad,
            tutor_emp_id: idTutorEmp
        };
        try {
            if (idHoraPracticaExistente) {
                // 🔄 Actualizar registro existente
                const urlUpdate = `${ApiUrl}horaspracticaslabestud/${idHoraPracticaExistente}?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71`;
                await axios.put(urlUpdate, payload);
                swal("Actualizado", "Horas prácticas actualizadas correctamente", "warning");
            } else {
                // 🆕 Registrar nuevo
                await axios.post(urlGuardarHorasPractica, payload);
                swal("Registrado", "Horas prácticas registradas correctamente", "warning");
            }

            this.cerrarModal();
            this.listarEstudiantes();

        } catch (error) {
            console.error("Error al guardar o actualizar:", error);
            swal("Error", "No se pudo procesar el registro", "error");
        }
    };
    //Modificar información del documento
    modificarInformacionDocumento = (e, doc) => {
        // Identificadores dinámicos de cada campo
        const idBase = this.state.idHorasPractLabEstud + "" + doc.id_documento_practica_laboral;
        const idSelectEstadoDoc = "estdocpractlab" + idBase;
        const idObservcionDoc = "obsdocpractlab" + idBase;
        const idInputFile = "filedocpractlab" + idBase;

        // Obtener valores desde el DOM
        const idEstado = document.getElementById(idSelectEstadoDoc)?.value || 0;
        const observacion = document.getElementById(idObservcionDoc)?.value || "";
        const inputFile = document.getElementById(idInputFile);
        const archivo = inputFile?.files?.[0] || null;

        // Si hay archivo, validar tipo
        if (archivo) {
            const allowedTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];

            if (!allowedTypes.includes(archivo.type)) {
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return; // Detener si el archivo no es válido
            }
        }

        // Construir formData
        const formData = new FormData();
        formData.append("idestadodocument", idEstado);
        formData.append("observaciondoc", observacion);
        formData.append("iddocumentoestudiante", doc.id_documento_practica_laboral);
        formData.append("idhoraspractlabest", this.state.idHorasPractLabEstud);

        // Solo agregar el archivo si existe
        if (archivo) {
            formData.append("archivorevisado", archivo);
        }

        const config = {
            headers: { "Content-Type": "multipart/form-data" },
        };

        axios
            .post(urlRespuestaDocumentos, formData, config)
            .then((response) => {
                if (response.data.success) {
                    swal({
                        text: "Información actualizada correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });

                    // Refrescar la lista de documentos
                    axios
                        .post(urlListaDocsPracticasEst, {
                            idCarrera: this.state.idCarrera,
                            idEstudiante: this.state.idEstudianteSelect,
                            idPeriodo: this.state.idPeriodo,
                        })
                        .then((res) => {
                            if (res.data?.success) {
                                this.setState({ documentosPracticas: res.data.data || [] });
                            } else {
                                this.setState({ documentosPracticas: [] });
                                swal("Información", "No existen documentos registrados para este estudiante.", "info");
                            }
                        })
                        .catch(() => {
                            this.setState({ documentosPracticas: [] });
                            swal("Error", "No se pudo obtener la información.", "error");
                        });
                } else {
                    swal({
                        text: response.data.message || "Error al actualizar la información.",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                swal({
                    text: "No se pudo conectar con el servidor.",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    };


    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-file-alt bounce-custom fs-5"></i>
                        <b className="ms-2">Gestión de Horas Prácticas Laborales</b>
                    </div>

                    {/* Buscador y Filtro */}

                    <div className="row mt-3">

                        <div className="col-12 col-sm-12 col-lg-3 text-azul">
                            <label><b><i className="fa-magnifying-glass"></i> Buscar:</b></label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={this.state.text}
                                placeholder="Buscar..."
                                onChange={(text) => this.filter(text)}
                            />

                        </div>

                        <div className="col-12 col-sm-12 col-lg-3 text-azul">
                            <label><b><i className="fa fa-calendar"></i> Período:</b></label>
                            <select className="form-select form-select-sm" id="idPeriodo" name="idPeriodo" onChange={this.handleChangePeriodo}>
                                <option disabled selected>Seleccione el período</option>
                                {this.state.periodos.map((p) => (
                                    <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                        {p.descripcion_periodo_academico}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-sm-12 col-lg-3 text-azul">
                            <label><b><i className="fa fa-graduation-cap"></i> Carrera:</b></label>
                            <select className="form-select form-select-sm" id="idCarrera" name="idCarrera" onChange={this.handleChangeSelectNivel} >
                                <option disabled selected>Seleccione la carrera</option>
                                {this.state.carrera.map((c) => (
                                    <option key={c.id_carrera} value={c.id_carrera}>
                                        {c.descripcion_carrera}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="col-12 col-sm-12 col-lg-2 text-azul">
                            <div className="mb-3">
                                <label className="form-label"><b>Nivel</b></label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idNivelCarr"
                                    name="idNivelCarr"
                                    value={this.state.idNivelCarr || ""}
                                    onChange={this.handleChange}
                                >
                                    <option value="" disabled>Seleccione</option>
                                    {this.state.listaniveles.map(person => (
                                        <option key={person.codnivel} value={person.codnivel}>
                                            {person.valor}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>


                        <div className="col-12 col-sm-6 col-lg-1 text-azul">
                            <div
                                className="d-flex align-items-center justify-content-center w-100 border rounded-3 shadow-sm py-1 px-2"
                                style={{ backgroundColor: "#f8f9fa" }}
                            >
                                <i className="fa fa-clock text-azul me-2 fa-lg animate__animated animate__pulse animate__infinite"></i>
                                <div className="d-flex flex-column text-center">
                                    <small className="text-muted lh-1">Horas</small>
                                    <span className="fw-bold text-azul fs-6">
                                        {this.state.horasPracticasLaboralesCarrera || 0}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="row mt-4" >
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr className="text-azul text-start">
                                            <th>Cédula</th>
                                            <th>Primer Apellido</th>
                                            <th>Segundo Apellido</th>
                                            <th>Primer Nombre</th>
                                            <th>Segundo Nombre</th>
                                            <th>Horas Faltantes Carrera</th>
                                            <th>Horas Período</th>
                                            <th>Horas Cumplidas Período</th>
                                            <th>Horas Faltantes Período </th>
                                            <th>Acción</th>
                                            <th>Estado</th>
                                            <th>Documentos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems &&
                                            this.state.currentItems.map((estud) => (
                                                <tr className="text-azul text-start" key={estud.id_estudiante}>
                                                    <td>{estud.numero_identificacion_estudiante}</td>
                                                    <td>{estud.primer_apellido_estudiante}</td>
                                                    <td>{estud.segundo_apellido_estudiante}</td>
                                                    <td>{estud.primer_nombre_estudiante}</td>
                                                    <td>{estud.segundo_nombre_estudiante}</td>
                                                    <td>{this.state.horasPracticasLaboralesCarrera - estud.total_horas_cumplidas}</td>
                                                    <td>{estud.hor_asig}</td>
                                                    <td>{estud.hor_cump}</td>
                                                    <td>{estud.hor_asig - estud.hor_cump}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-link p-0"
                                                            onClick={() => this.abrirModalHoras(estud)}
                                                            title="Ver/Editar"
                                                        >
                                                            <i className="fas fa-pen text-azul bounce-custom"></i>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {(() => {
                                                            if (estud.est_doc_aprobdocen == 4) {
                                                                return <span className="badge bg-warning text-dark small rounded-pill">Procesar</span>;
                                                            }
                                                            else
                                                                if (estud.est_doc_aprobsupervisor == 1) {
                                                                    return (<span className="d-inline-flex align-items-center gap-1 text-success small">
                                                                        <i className="fas fa-check-circle"></i>
                                                                        <span>Completo</span>
                                                                    </span>);
                                                                }
                                                        })()}
                                                    </td>
                                                    <td>
                                                        {Number(estud.id_hor_prac_lab_est) !== 0 ? (
                                                            <input
                                                                type="radio"
                                                                value="1"
                                                                name="interfazdocument"
                                                                onChange={() => this.seleccionarEstudiantePracticas(estud)}
                                                            />
                                                        ) : (
                                                            <span className="text-muted"></span>
                                                        )}
                                                    </td>


                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                <div className="d-flex justify-content-center mt-4">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        forcePage={this.state.currentPage || 0}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />


                                </div>
                            </div>
                        </div>
                    </div>



                    {/* ===================== LISTA DE DOCUMENTOS ===================== */}
                    <div id="divReporteDocPractLab" className="p-3 rounded-3 mt-3" >
                        <h6 className="fw-bold text-center mb-3 text-azul">
                            Reporte de Documentos de Prácticas Laborales
                        </h6>

                        <div className="table-responsive">
                            <table
                                className="table table-hover table-sm-custom"
                                id="tablaDocumentosPracticas"
                                width="100%"
                            >
                                <thead className="table-light">
                                    <tr className="text-start text-azul">
                                        <th>No</th>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th>Formato</th>
                                        <th>Archivo Subido</th>
                                        <th>Fecha de Envío</th>
                                        <th>Observación</th>
                                        <th>Cargar</th>
                                        <th>Estado</th>
                                        <th>Responder</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(this.state.documentosPracticas) &&
                                        this.state.documentosPracticas.length > 0 ? (
                                        this.state.documentosPracticas.map((doc, index) => (
                                            <tr className="text-start text-azul" key={doc.id_registro || index}>
                                                <td>{index + 1}</td>
                                                <td>{doc.nombre_documento}</td>
                                                <td>
                                                    <button
                                                        onClick={() => this.mostrarModalDescripDocumento(doc.descripcion_documento)}
                                                        style={{ background: "none", border: "none", cursor: "pointer" }}
                                                        title="Ver descripción"
                                                    >
                                                        <i className="fa fa-2x fa-align-left text-primary"></i>
                                                    </button>
                                                </td>
                                                <td>
                                                    {doc.ruta_formato ? (
                                                        <a href={doc.ruta_formato} target="_blank" rel="noopener noreferrer">
                                                            <i className="fa fa-2x fa-file-alt text-danger"></i>
                                                        </a>
                                                    ) : (
                                                        <span className="small text-muted">Sin archivo</span>
                                                    )}
                                                </td>
                                                {/* Archivo cargado */}
                                                <td>
                                                    {doc.ruta_cargada ? (
                                                        <a
                                                            href={doc.ruta_cargada}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i
                                                                className="fa fa-2x fa-file-alt text-success"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </a>
                                                    ) : (
                                                        <span className="small text-muted">Sin archivo</span>
                                                    )}
                                                </td>

                                                <td>{doc.fecha_envio || "-"}</td>

                                                <td>
                                                    <textarea
                                                        name={`obsdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        id={`obsdocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        onChange={(e) => this.handleChangeObservacion(e, doc.id_documento_practica_laboral)}
                                                        className="form-control"
                                                        placeholder=""
                                                        maxLength="500"
                                                        required
                                                        disabled={this.state.isDisabled}
                                                        value={doc.observacion_documento || ''}
                                                    />


                                                </td>

                                                <td class="detalle">
                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx"
                                                        id={`filedocpractlab${this.state.idHorasPractLabEstud}${doc.id_documento_practica_laboral}`}
                                                        className="form-control form-control-sm"
                                                    />
                                                </td>

                                                <td class="estadodocument">
                                                    <select className="form-select" name={"estdocpractlab" + this.state.idHorasPractLabEstud + doc.id_documento_practica_laboral} id={"estdocpractlab" + this.state.idHorasPractLabEstud + doc.id_documento_practica_laboral} value={this.state.value} aria-label="Default select example">
                                                        <option value="0" >Seleccione</option>
                                                        <option value="1">Enviado</option>
                                                        <option value="2">Aprobado por el supervisor</option>
                                                        <option value="3">Rechazado</option>
                                                        <option value="4">Aprobado por el tutor/a</option>

                                                    </select>
                                                    {(() => {
                                                        if (doc.estado_documento > 0) {
                                                            var nom = this.state.idHorasPractLabEstud + doc.id_documento_practica_laboral;
                                                            $(function () {
                                                                var nombrevar = nom + "";
                                                                $("#estdocpractlab" + nombrevar).val(doc.estado_documento);
                                                            });
                                                        } else {
                                                            var nom = this.state.idHorasPractLabEstud + doc.id_documento_practica_laboral;
                                                            $(function () {
                                                                var nombrevar = nom + "";
                                                                $("#estdocpractlab" + nombrevar).prop('selectedIndex', 0); // o .val('') si usas un value vacío
                                                            });
                                                        }

                                                    })()}

                                                </td>

                                                <td>

                                                    {(() => {
                                                        if (doc.estado_documento == 0) {

                                                            return <span className="small text-muted">Pendiente</span>
                                                        }
                                                        else {
                                                            if (doc.estado_documento === 2) {
                                                                return (
                                                                    <span className="small text-success">
                                                                        <i className="fas fa-check-circle"></i> Aprobado por el supervisor
                                                                    </span>
                                                                );
                                                            }
                                                            else {
                                                                if (doc.estado_documento === 4) {
                                                                    return (
                                                                        <button
                                                                            onClick={(e) => this.modificarInformacionDocumento(e, doc)}
                                                                            className="btn btn-sm btn-warning rounded-pill"
                                                                        >
                                                                            <i className="fas fa-clipboard-check"></i>
                                                                        </button>
                                                                    );
                                                                } else {
                                                                    return (
                                                                        <button
                                                                            onClick={(e) => this.modificarInformacionDocumento(e, doc)}
                                                                            className="btn btn-sm btn-secondary rounded-pill"
                                                                        >
                                                                            <i className="fas fa-clipboard-check"></i>
                                                                        </button>
                                                                    );
                                                                }
                                                            }
                                                        }
                                                    })()}

                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center text-muted">
                                                No existen documentos para mostrar.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Modal isOpen={this.state.modalDescripcionDocumento}>
                            <ModalHeader>
                                <h5>Descripción del Documento</h5>
                            </ModalHeader>
                            <ModalBody>
                                <div className="mb-3 centrar">
                                    <p className="texto-justificado">{this.state.descripcionDocumento}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={this.ocultarModalDescripDocumento}
                                >
                                    Cerrar
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>

                {/* ===================== MODAL ===================== */}
                <Modal isOpen={this.state.modalHoras} toggle={this.cerrarModal}>
                    <ModalHeader>
                        Registrar / Editar Horas Prácticas
                    </ModalHeader>

                    <ModalBody>

                        {/* =================== DATOS DEL ESTUDIANTE =================== */}
                        {this.state.estudianteSeleccionado && (
                            <p className="text-azul text-start">
                                <b >Estudiante:</b>{" "}
                                {this.state.estudianteSeleccionado.primer_apellido_estudiante}{" "}
                                {this.state.estudianteSeleccionado.segundo_apellido_estudiante}{" "}
                                {this.state.estudianteSeleccionado.primer_nombre_estudiante}{" "}
                                {this.state.estudianteSeleccionado.segundo_nombre_estudiante}
                            </p>
                        )}

                        {/* =================== HORAS DE LA CARRERA =================== */}
                        <p>
                            <b className="text-azul text-start">Horas faltantes en la carrera:</b>{" "}
                            {this.state.horasFaltanteCarr}
                        </p>

                        {/* =================== DIVISIÓN EN DOS COLUMNAS =================== */}
                        <div className="row">

                            {/* =================== COLUMNA 1 =================== */}
                            <div className="col-md-6">
                                <FormGroup>

                                    <label className="mt-2">Horas asignadas en el período</label>
                                    <input
                                        type="number"
                                        className="form-control mb-3"
                                        value={this.state.horasAsignadasPeriodo}
                                        onChange={(e) => this.setState({ horasAsignadasPeriodo: e.target.value })}
                                    />

                                    <label className="mt-2">Horas cumplidas en el período</label>
                                    <input
                                        type="number"
                                        className="form-control mb-3"
                                        value={this.state.horasCumplidasPeriodo}
                                        onChange={(e) => this.setState({ horasCumplidasPeriodo: e.target.value })}
                                    />

                                    <label className="mt-2">Observación</label>
                                    <textarea
                                        className="form-control mb-3"
                                        rows="4"
                                        value={this.state.observacion}
                                        onChange={(e) => this.setState({ observacion: e.target.value })}
                                    ></textarea>

                                </FormGroup>
                            </div>

                            {/* =================== COLUMNA 2 =================== */}
                            <div className="col-md-6">
                                <FormGroup>

                                    <label className="mt-2">Entidades</label>
                                    <select
                                        className="form-select mb-3"
                                        id="idEntidad"
                                        name="idEntidad"
                                        value={this.state.idEntidad}
                                        onChange={this.handleChangeListTutorEmpEnt}
                                    >
                                        <option value="">Seleccione una entidad</option>
                                        {this.state.entidades.map((ent) => (
                                            <option key={ent.id} value={ent.id}>
                                                {ent.nombre_entidad}
                                            </option>
                                        ))}
                                    </select>

                                    <label className="mt-2">Tutores empresariales</label>
                                    <select
                                        className="form-select mb-3"
                                        id="idTutorEmp"
                                        name="idTutorEmp"
                                        onChange={this.handleChange}
                                    >
                                        <option disabled selected>Seleccione un tutor</option>
                                        {this.state.tutoresempresariales.map((tutoremp) => (
                                            <option key={tutoremp.id} value={tutoremp.id}>
                                                {tutoremp.nombres_tutores_empresariales + " " + tutoremp.apellidos_tutores_empresariales}
                                            </option>
                                        ))}
                                    </select>

                                    <label className="mt-2">Tutores académicos</label>
                                    <select
                                        className="form-select mb-3"
                                        id="idTutorAcad"
                                        name="idTutorAcad"
                                        onChange={this.handleChange}
                                    >
                                        <option disabled selected>Seleccione un tutor académico</option>
                                        {this.state.docentes.map((docent) => (
                                            <option key={docent.id_administrativo} value={docent.id_administrativo}>
                                                {docent.nombres_administrativo + " " + docent.apellidos_administrativo}
                                            </option>
                                        ))}
                                    </select>

                                </FormGroup>
                            </div>

                        </div>

                    </ModalBody>

                    <ModalFooter>
                        <Button color="primary" onClick={this.guardarHorasPractica}>
                            {this.state.idHoraPracticaExistente ? "Actualizar" : "Registrar"}
                        </Button>
                        <Button color="secondary" onClick={this.cerrarModal}>Cancelar</Button>
                    </ModalFooter>
                </Modal>



            </div>
        );
    }
}
